import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import * as actions from "../../redux/actions/index";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import logo from "../../images/lo-logo-2.png"

export default function Login(props) {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const user = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const emailUpdateHandler = (event) => {
        setEmail(event.target.value);
    };

    const passwordUpdateHandler = (event) => {
        setPassword(event.target.value);
    };

    const submitHandler = (event) => {
        event.preventDefault();
        setLoading(true);
        dispatch(actions.userLogin(email, password))
            .then((response) => {
                history.push("");
            })
            .catch((error) => {
                console.log(error);
            });
        setLoading(false);
    };

    const handleHistory = () => {
        let message = "";
        if (history?.location?.state?.message) {
            message = history.location.state.message;
            window.history.replaceState(null, "");
        }
        return message;
    };

    return (
        <React.Fragment>
            {history?.location?.state?.message ? (
                <Typography variant="body1" component="p" color="success">
                    {handleHistory()}
                </Typography>
            ) : (
                ""
            )}
            {user.errorMessage ? (
                <Typography variant="body1" component="p" color="error">
                    {user.errorMessage}
                </Typography>
            ) : (
                ""
            )}
            <form className={props.classes.loginForm} onSubmit={submitHandler}>
                <TextField
                    className={props.classes.loginInput}
                    id="email"
                    type="email"
                    label="Email Address"
                    onChange={emailUpdateHandler}
                    value={email}
                />
                <TextField
                    className={props.classes.loginInput}
                    id="password"
                    type="password"
                    label="Password"
                    onChange={passwordUpdateHandler}
                    value={password}
                />
                <Button
                    className={props.classes.loginButton}
                    type="submit"
                    variant="contained"
                    color="primary"
                >
                    LOGIN
                </Button>
            </form>
            <Button
                className={props.classes.signUp}
                color="primary"
                component={Link}
                to="/register"
                variant="text"
            >
                Sign Up
            </Button>
            <Typography
                className={props.classes.poweredBy}
                component="p"
                variant="caption"
            >
                Powered by
            </Typography>
            <img src={logo} style={{width: "auto", height:"50px", margin: "auto", display: "block"}} alt="Listonce Logo"></img>
            <CSSTransition
                appear
                classNames="fade-animation"
                in={loading}
                key="login-loading"
                timeout={1000}
                unmountOnExit
            >
                <div className={props.classes.loginLoadingOverlay}>
                    <CircularProgress />
                </div>
            </CSSTransition>
        </React.Fragment>
    );
}
